import React from 'react';
import classStyle from './Notice.module.scss';
import noticeBack from '@src/assets/noticeBack.png';
import noticeType from '@src/assets/noticeType.png';
import noticeWaiting from '@src/assets/noticeWaiting.png'; 
import { isAndroid } from '@src/unit';
import { useLocation } from 'react-router-dom';


export default function Notice() {
    const search = useLocation().search;
    const tag = new URLSearchParams(search).get('tag');
    const type = new URLSearchParams(search).get('type');
    const isPwa = type === null || type === 'pwa';
    return (
        <div className={classStyle.noticePage}>
            {isAndroid && window.open('ubitrp://resume', '_blank')}
            {isPwa && <img src={noticeBack} className={classStyle.noticeBack} alt="" /> }
            {!isPwa && <div style={{height:"15%"}}/> }
            {tag === 'pay'?
                <img src={noticeWaiting} className={classStyle.noticeType} alt="" /> :
                <img src={noticeType} className={classStyle.noticeType} alt="" />}
            {tag === 'pay' && <div className={classStyle.waitingPayText}>
                <span>等待交易方确认订单中</span>
                </div>
            }
            
            {isPwa && <div className={classStyle.noticePage}>
                <div className={classStyle.text}>
                    <span>可点击左上角</span>
                    <span className={classStyle.redText}>【完成】</span>
                    <span>返回应用</span>
                </div>
                <div className={classStyle.text}>
                    或者
                </div>
                <div className={classStyle.redText}>
                    请关闭优币，重新打开应用
                </div>
            </div>}

            {!isPwa && <div className={classStyle.text}>
                您已完成操作，请返回UBIT钱包确认。
            </div>}

        </div>
    );
};
